import { Container } from './styles';

const masonryOptions = {
  gutter: 10,
  transitionDuration: 0,
  columnWidth: 180,
  initLayout: true,
  resize: true,
  fitWidth: false,
};

const GridContainer = ({
  children,
  onImagesLoaded,
}) => {
  return (
    <Container
      options={masonryOptions}
      disableImagesLoaded={false}
      updateOnEachImageLoad
      onImagesLoaded={onImagesLoaded}
    >
      {children}
    </Container>
  );
};

export default GridContainer;
